module.exports = __webpack_public_path__ + "img/h6.e5a9d17e.png";